import React, { useState } from "react";
import { required, SimpleForm, FormDataConsumer, Button, ArrayField, Toolbar, SaveButton, Edit, Create, BooleanInput, 
  Datagrid, TextField, TextInput, AutocompleteInput, ReferenceInput, SelectInput, BooleanField, 
  RadioButtonGroupInput } 
  from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
import dataProvider from './dataprovider'
import Box from '@material-ui/core/Box';
import { useForm, useFormState } from 'react-final-form';
const utils = require('./components/utils');

const BatchCreateToolbar = props => (
  <Toolbar {...props} >
    <SaveButton label="  Save Batch " redirect="edit" submitOnEnter={false} />
  </Toolbar>
);

const validateAdsTxtFormat = fd => {
  const errors = {};
  if (fd.adstxt_domain) {
    if (fd.type && fd.type === 'app' && !fd.adstxt_domain.endsWith('/app-ads.txt')) {
      errors.adstxt_domain = {message: 'Format should be like http://www.site.com/app-ads.txt'};
    } else if (fd.type && fd.type !== 'app' && fd.adstxt_domain.endsWith('/app-ads.txt')) {
      errors.adstxt_domain = {message: 'Format should be like http://www.site.com/ads.txt'};
    }
  }
  return errors;
}

export const SiteBatchCreate = (props) => {
  const [adPaths, setAdPaths] = useState();

  function getAdPaths(id) {
    console.log("Publisher id: " + id);
    dataProvider.getOne('publishers', { id: id }).then(publisher => {
        console.log(publisher.data['ad_unit_paths'])
        setAdPaths(publisher.data['ad_unit_paths']);
    })
  }

  const AdParentInput = props => {
    const form = useForm();
    const {values} = useFormState();
  
    if (adPaths && adPaths.length > 1) {
        if (values.ad_unit_parent_id && !adPaths.map(x=>x.id).includes(values.ad_unit_parent_id)) {
            form.change('ad_unit_parent_id', null);
        }
        return (
            <SelectInput
                choices={adPaths}
                {...props} source="ad_unit_parent_id" label="Ad Unit Parent" validate={required()}
            />
        );
    }
    if (adPaths && adPaths.length>0 && adPaths.length < 2) form.change('ad_unit_parent_id', adPaths[0].id);
    return null
  };

  return (
    <Create title="Batch Sites" {...props}>
      <SimpleForm toolbar={<BatchCreateToolbar />} validate={validateAdsTxtFormat} validateOnBlur={true} >
        <br/>
        <RadioButtonGroupInput source="operation" choices={[
            { id: 'create', name: 'Create' },
            { id: 'update', name: 'Update' }
        ]} defaultValue='create' style={{ fontWeight: "bold" }}/>
        <br/>


        <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='create')
                && <BooleanInput source="adstxt" label="Crawl Ads.txt?" defaultValue={true} style={{display: 'none'}}/>
            }
        </FormDataConsumer>
        
        <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
          <FormDataConsumer>
              {({ formData }) => (formData && formData.operation==='create')
                  && <SelectInput label="Type" source="type" choices={utils.SITE_TYPES} validate={required()} />
              }
          </FormDataConsumer>
          {/* <FormDataConsumer>
            {({ formData }) => { 
              if (formData && formData.operation==='create') {
                const adsTxtType = formData.type === "app" ? "app-ads.txt" : "ads.txt";

                return <TextInput
                  source="adstxt_domain"
                  label={`${ adsTxtType } location`}
                  helperText={ `${ adsTxtType } location, ie: http://www.site.com/${adsTxtType}` }
                  style={{ width: '30%', marginLeft: '20px' }}
                  validate={ formData.type === "app" ? required() : null }
                />
              }
            }}
          </FormDataConsumer> */}
        </Box>
        {/* <BooleanInput source="appnexus" label="Setup Appnexus IDs?" defaultValue={false} /> */}
        

        {/* <FormDataConsumer>
            {({ formData }) => formData
                && <SelectInput source="appnexus" label="Select Appnexus Account?" defaultValue={''} allowEmpty={true}
                choices={[
                  {id : "appn1", name: "Appnexus 1"},
                  {id : "appn2", name: "Appnexus 2"}
                ]} 
                style={{width: '300px'}}
                Xvalidate={ formData.operation === "update" ? required() : null }/>
            }
        </FormDataConsumer> */}
        
        <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='create')
                && [<BooleanInput source="fast_lane_enabled" style={{ width: '250px', display: 'none' }} label="Enable Fast Lane" defaultValue={true}
                helperText="Fast lane enables for faster ad rendering by skipping GAM/DFP. Use this flag with caution b/c this will eliminate Google Dynamic Allocation revenue. Only use for sites that are not approved on Google." />
                , <br/>, <br/>
                ]
            }
        </FormDataConsumer>

        {/* <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='create')
                && <SelectInput style={{ width: '350px' }} source="default_bidder_id"
                label="Default Prediction Bidder"
                defaultValue={606}
                choices={utils.BIDDERS_PREDICTORS} />
            }
        </FormDataConsumer> */}

        {/* <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='create')
                && <SelectInput style={{ width: '350px' }} label="Prediction Pace" source="prediction_throttle_pace"
                helperText="10% means that predictions are only used 10% of the time for this sites. Use this for new sites until the predictions stabilize."
                defaultValue={10}
                choices={[
                  { id: 0, name: '0%' },
                  { id: 1, name: '1%' },
                  { id: 5, name: '5%' },
                  { id: 10, name: '10%' },
                  { id: 15, name: '15%' },
                  { id: 20, name: '20%' },
                  { id: 25, name: '25%' },
                  { id: 50, name: '50%' },
                  { id: 75, name: '75%' },
                  { id: 80, name: '80%' },
                  { id: 90, name: '90%' },
                  { id: 100, name: '100%' },
                ]} />
            }
        </FormDataConsumer> */}

        <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='create')
                && [
                  <div style={{ width: '100%' }}>
                  <br /><h3>Select Publisher</h3>
                  </div>,
                  <ReferenceInput source="publisher_id" label="Publisher" reference="publishers" onChange={(e) => { getAdPaths(e) }}
                    perPage={10} validate={required()}
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                  >
                  <AutocompleteInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
                  </ReferenceInput>,
                  <AdParentInput />
                ]
            }
        </FormDataConsumer>
        
        <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='create')
                && <div style={{ width: '100%' }}>
                <br /><h3>Batch Format For Sites:</h3>
                {(formData.type==='app') ? <>site_name*,app-ads.txt_url,store_url(for apps only) </>: <>site_name</>}
                <br />
              </div>
            }
        </FormDataConsumer>

        <FormDataConsumer>
            {({ formData }) => (formData && formData.operation==='update')
                && <div style={{ width: '100%' }}>
                <br /><h3>Batch Format For Sites:</h3>
                site_id*
                <br />
              </div>
            }
        </FormDataConsumer>
        
        <TextInput multiline source="content" label="Sites Batch"
          initialValue=""
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}

const EmptyToolbar = props => (
  <Toolbar {...props} >
    <Button href="/#/batch/" label="Back to Batch processing" variant="contained" color="primary" startIcon={<EditIcon />} />
  </Toolbar>
);
export const SiteBatchEdit = (props) => (
  <Edit title="Batch Results" {...props} >
    <SimpleForm toolbar={<EmptyToolbar />} >
      <BooleanField source="success" label="Success?" />
      <ArrayField source="messages" label="Messages" style={{ width: '100%' }} >
        <Datagrid>
          <TextField source="message" />
        </Datagrid>
      </ArrayField>
    </SimpleForm>
  </Edit>
);
